module.exports = __webpack_public_path__ + "img/thief.aa246628.svg";